import React from 'react';
import { useSelector } from 'react-redux';

import { Select, Input, InputNumber } from 'antd';

import { getAsNumber } from '../../../../../../../utilities/numberConvertion';
import FileUpload from '../../../../../../../components/FileUpload';

const getOptions = (list) => {
  return list.map((item) => ({
    value: item.value,
    label: <div>{item.label}</div>
  }));
};

export const TableCol = (action, status) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { supervision_course: supervisionCourse } = staticData;

  return [
    {
      key: 'name',
      dataIndex: 'name',
      title: 'Course',
      render: (value, row) => {
        const _courseType =
          supervisionCourse.length > 0
            ? supervisionCourse.filter((item) => item.value === Number(value))
            : [];
        const _course = _courseType.length ? _courseType[0] : {};

        const { value: courseValue } = _course;

        return supervisionCourse?.length ? (
          <Select
            style={{ width: '230px' }}
            options={getOptions(supervisionCourse)}
            defaultValue={courseValue}
            placeholder="Select a Course"
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) => {
              action({
                ...row,
                name: e
              });
            }}
          />
        ) : (
          <></>
        );
      }
    },
    {
      key: 'no_student',
      dataIndex: 'no_student',
      title: 'No. of students',
      render: (value, row) => (
        <InputNumber
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          min={0}
          onChange={(e) => action({ ...row, no_student: e })}
        />
      )
    },
    {
      key: 'section',
      dataIndex: 'section',
      title: 'Section',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, section: getAsNumber(e.target.value) })}
        />
      )
    },
    {
      key: 'upload',
      dataIndex: 'attachment',
      title: 'Attachments',
      render: (fileList, row) => (
        <FileUpload
          fileList={fileList}
          row={row}
          action={action}
          disabled={status === 1 || status === 2 || status === 3}
          status={status}
        />
      )
    }
  ];
};